// extracted by mini-css-extract-plugin
export default {"avatar":"twOHKIVE4AJ9QGj9pZTyctZpZZ4WgwMPHaJq3+I7cBQ="};